var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 737.89 179.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e0ba56;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_7",
    "data-name": "Capa 7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.64,39.98h-11.87v-8.84h33.64v8.84h-11.88v62.25h-9.89v-62.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.76,49.42v34.31c0,13.15-5.72,19.51-17.57,19.51s-16.62-6.78-16.62-19.36v-34.5c0-12.97,6.51-19.23,17.26-19.23s16.93,6.63,16.93,19.28ZM254.64,48.65v36.24c0,6.79,2.55,9.73,7,9.73,4.75,0,7.05-2.8,7.05-9.97v-36.04c0-6.45-2.17-9.78-7.08-9.78-4.61,0-6.97,3.07-6.97,9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.22,69.85v32.38h-9.88V31.14h14.54c11.16,0,17.28,4.45,17.28,16.81v2.94c0,10.39-4.17,13.66-7.5,14.89,4.46,1.83,6.8,4.99,6.8,14.58,0,6.02-.11,17.5.69,21.88h-9.58c-.96-4.35-.77-16.14-.77-21.23,0-8.9-1.24-11.15-8.13-11.15h-3.45ZM297.22,61.91h3.54c6.43,0,8.48-2.91,8.48-10.59v-2.74c0-5.91-1.46-9.49-8.29-9.49h-3.73v22.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.5,69.85v32.38h-9.88V31.14h14.54c11.16,0,17.28,4.45,17.28,16.81v2.94c0,10.39-4.17,13.66-7.5,14.89,4.46,1.83,6.8,4.99,6.8,14.58,0,6.02-.11,17.5.69,21.88h-9.58c-.96-4.35-.77-16.14-.77-21.23,0-8.9-1.24-11.15-8.13-11.15h-3.45ZM337.5,61.91h3.54c6.43,0,8.48-2.91,8.48-10.59v-2.74c0-5.91-1.46-9.49-8.29-9.49h-3.73v22.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394.04,68.94h-16.34v24.53h18.72l-1.28,8.77h-27.32V31.14h27.14v8.84h-17.26v20.19h16.34v8.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.17,81.69v4.28c0,5.88,1.96,9.09,6.64,9.09s6.33-3.9,6.33-9.85c0-7.93-1.79-10.66-9.63-16.6-7.91-6-12.05-9.75-12.05-20.26,0-9.22,2.88-18.33,15.45-18.3,12.5.03,14.94,8.41,14.94,16.68v3.59h-9.81v-3.33c0-5.35-1-8.69-5.31-8.69s-5.38,3.59-5.38,8.67c0,5.69,1.15,8.17,7.75,12.89,10.69,7.7,14.02,12.09,14.02,23.95,0,10.05-3.37,19.41-16.57,19.41s-16.25-8.02-16.25-17.38v-4.16h9.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M497.41,59.33l-11.46,26.97c-4.81,11.21-9.86,16.72-18.57,16.72-10.67,0-15.19-7.9-15.19-19.27s4.45-15.44,13.85-22.87c6.82-5.38,8.67-8,8.67-15.16,0-4.62-.81-7.64-4.49-7.64-3.41,0-4.55,3.39-4.55,7.66,0,6.01.44,8.52,3.82,13.84l27.31,42.65h-11.06l-23.29-35.96c-4.65-7.18-5.97-11.05-5.97-19.63,0-10.38,4.85-16.35,13.66-16.35s13.49,5.4,13.49,15.44-3.02,13.74-12.9,21.25c-7.16,5.52-8.85,8.03-8.85,16,0,7.22,2.38,10.66,6.81,10.66s6.23-2.99,9.02-9.65l10.27-24.65h9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M524.42,39.98h-11.87v-8.84h33.64v8.84h-11.88v62.25h-9.89v-62.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M583.54,49.42v34.31c0,13.15-5.72,19.51-17.57,19.51s-16.62-6.78-16.62-19.36v-34.5c0-12.97,6.51-19.23,17.26-19.23s16.93,6.63,16.93,19.28ZM559.42,48.65v36.24c0,6.79,2.55,9.73,7,9.73,4.75,0,7.05-2.8,7.05-9.97v-36.04c0-6.45-2.17-9.78-7.08-9.78-4.61,0-6.97,3.07-6.97,9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M602,69.85v32.38h-9.88V31.14h14.54c11.16,0,17.28,4.45,17.28,16.81v2.94c0,10.39-4.17,13.66-7.5,14.89,4.46,1.83,6.8,4.99,6.8,14.58,0,6.02-.11,17.5.69,21.88h-9.58c-.96-4.35-.77-16.14-.77-21.23,0-8.9-1.24-11.15-8.13-11.15h-3.45ZM602,61.91h3.54c6.43,0,8.48-2.91,8.48-10.59v-2.74c0-5.91-1.46-9.49-8.29-9.49h-3.73v22.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642.28,69.85v32.38h-9.88V31.14h14.54c11.16,0,17.28,4.45,17.28,16.81v2.94c0,10.39-4.17,13.66-7.5,14.89,4.46,1.83,6.8,4.99,6.8,14.58,0,6.02-.11,17.5.69,21.88h-9.58c-.96-4.35-.77-16.14-.77-21.23,0-8.9-1.24-11.15-8.13-11.15h-3.45ZM642.28,61.91h3.54c6.43,0,8.48-2.91,8.48-10.59v-2.74c0-5.91-1.46-9.49-8.29-9.49h-3.73v22.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M698.82,68.94h-16.34v24.53h18.72l-1.28,8.77h-27.32V31.14h27.14v8.84h-17.26v20.19h16.34v8.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M714.95,81.69v4.28c0,5.88,1.96,9.09,6.64,9.09s6.33-3.9,6.33-9.85c0-7.93-1.79-10.66-9.63-16.6-7.91-6-12.05-9.75-12.05-20.26,0-9.22,2.88-18.33,15.45-18.3,12.5.03,14.94,8.41,14.94,16.68v3.59h-9.81v-3.33c0-5.35-1-8.69-5.31-8.69s-5.38,3.59-5.38,8.67c0,5.69,1.15,8.17,7.75,12.89,10.69,7.7,14.02,12.09,14.02,23.95,0,10.05-3.37,19.41-16.57,19.41s-16.25-8.02-16.25-17.38v-4.16h9.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.82,119.32h19.51v5.86h-12.19v6.4h11.44v5.81h-11.44v11.91h-7.32v-29.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.56,119.32v29.99h-7.45v-29.99h7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.75,137.46v11.85h-7.28v-29.99h12.64c6.15,0,9.8,3.17,9.8,8.23,0,4.06-2.06,6.05-4.46,7.01,2.91,1.17,3.9,3.53,3.9,7.2v.93c0,2.7.13,5.11.36,6.62h-7.16c-.43-1.25-.56-3.25-.56-6.7v-.88c0-3.27-1.03-4.27-4.3-4.27h-2.93ZM251.75,131.92h3.44c2.57,0,4.37-.88,4.37-3.67,0-2.47-1.59-3.42-3.76-3.42h-4.05v7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.34,139.2c0-4.78.09-11.04.21-14.56h-.25c-1.15,6.39-3.3,16.55-5.33,24.66h-6.13c-1.54-7.53-3.67-18.33-4.73-24.7h-.27c.23,3.51.37,9.73.37,14.91v9.8h-6.69v-29.99h10.82c1.49,6.03,3.31,15.24,3.95,19.68h.11c.66-4.47,2.91-13.17,4.57-19.68h10.5v29.99h-7.12v-10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.38,142.95l-1.57,6.36h-7.33l8.19-29.99h9.95l8.55,29.99h-7.76l-1.71-6.36h-8.32ZM320.44,136.96c-1.29-4.91-2.33-9.26-2.94-12.25h-.11c-.58,3.22-1.65,7.71-2.81,12.25h5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.24,119.32h7.45v24.13h12.27l-.75,5.85h-18.97v-29.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.55,136.73h-12.06v6.76h13.42l-.85,5.82h-19.79v-29.99h19.78v5.87h-12.55v5.68h12.06v5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.83,149.31h-5.35c-.19-.88-.37-2.12-.44-2.98-1.52,2.7-4.31,3.5-7.72,3.5-7.95,0-11.57-6.53-11.57-15.26,0-9.29,4.74-15.74,13.48-15.74,8,0,11.11,4.77,11.62,9.27h-7.32c-.37-1.52-1.21-3.57-4.58-3.57-4.1,0-5.49,4.2-5.49,10s1.48,9.63,5.53,9.63c3.42,0,4.49-2.48,4.49-5.67v-.48h-4.87v-5.74h12.23v17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.96,142.95l-1.57,6.36h-7.33l8.19-29.99h9.95l8.55,29.99h-7.76l-1.71-6.36h-8.32ZM433.02,136.96c-1.29-4.91-2.33-9.26-2.94-12.25h-.11c-.58,3.22-1.65,7.71-2.81,12.25h5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.86,119.32h7.45v24.13h12.27l-.75,5.85h-18.97v-29.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.69,131.39v5.79h-11.45v-5.79h11.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.15,139.59c-.68,5.07-3.86,10.24-11.97,10.24-9.64,0-12.69-6.93-12.69-15.48s4.17-15.52,12.97-15.52,11.35,5.76,11.56,10.1h-7.31c-.41-2.12-1.04-4.41-4.4-4.41-3.91,0-5.12,4.1-5.12,9.81s1.18,9.83,5.13,9.83c3.32,0,4.12-2.64,4.49-4.57h7.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.87,134.15c0,9.13-3.95,15.68-13.46,15.68s-12.99-6.67-12.99-15.74c0-8.16,4.03-15.26,13.41-15.26s13.04,6.86,13.04,15.32ZM535.15,134.08c0,6,1.7,10.09,5.53,10.09,4.18,0,5.49-3.76,5.49-10.08,0-5.55-1.28-9.59-5.58-9.59-3.95,0-5.44,3.8-5.44,9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.52,149.31v-29.99h9.01c6.65,15.82,7.94,19.11,8.32,20.46h.12c-.3-3.52-.38-8.52-.38-13.28v-7.18h6.77v29.99h-8.71c-7.16-17.55-8.18-20.26-8.56-21.41h-.08c.24,3.74.28,8.9.28,14.12v7.3h-6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.43,125.19h-7.5v-5.87h22.43v5.87h-7.47v24.12h-7.47v-24.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.4,142.95l-1.57,6.36h-7.33l8.19-29.99h9.95l8.55,29.99h-7.76l-1.71-6.36h-8.32ZM622.46,136.96c-1.29-4.91-2.33-9.26-2.94-12.25h-.11c-.58,3.22-1.65,7.71-2.81,12.25h5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M636.3,119.32h12.23c6.75,0,9.51,3.55,9.51,7.68,0,3.62-1.89,5.34-3.71,6.08,2.25.91,4.68,3.04,4.68,7.16,0,5.65-4.07,9.06-10.67,9.06h-12.04v-29.99ZM646.97,130.97c2.72,0,3.85-.89,3.85-3.18s-1.42-3.2-3.64-3.2h-3.64v6.38h3.43ZM643.54,144.08h3.78c2.31,0,4.06-1.08,4.06-3.94,0-2.66-1.36-4.02-4.47-4.02h-3.37v7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M663.27,119.32h7.45v24.13h12.27l-.75,5.85h-18.97v-29.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M705.57,136.73h-12.06v6.76h13.42l-.85,5.82h-19.79v-29.99h19.78v5.87h-12.55v5.68h12.06v5.86Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 97.66,
    width: 81.39,
    height: 81.39,
    rx: 8.06,
    ry: 8.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.28,
    y: 97.66,
    width: 81.39,
    height: 81.39,
    rx: 8.06,
    ry: 8.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 97.68,
    y: 0.5,
    width: 80.98,
    height: 80.98,
    rx: 8.02,
    ry: 8.02
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.82 66.83 135.37 69.61 135.37 36.77 140.82 34.1 140.82 66.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.92,12.77c-1.1,1.61-2.23,3.24-3.37,4.87-.92,1.32-1.85,2.62-2.77,3.91-.25-.64-.5-1.27-.75-1.91-1.25.82-2.52,1.63-3.8,2.44-13.78,8.63-27.67,15.19-41.2,20.17.97-.74,2.54-2.13,3.7-4.37.72-1.39,1.07-2.69,1.24-3.66,11.06-3.38,22.9-8.52,34.52-16.39,1.37-.93,2.69-1.86,3.98-2.81-.24-.73-.49-1.46-.73-2.19,1.22.16,2.6.27,4.1.28,1.9.01,3.61-.13,5.08-.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "129.79 64.16 124.34 66.97 124.34 43.78 122.6 42.86 129.79 39.39 129.79 64.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "151.82 53.47 146.29 56.28 146.29 32.95 144.67 32.12 151.82 28.62 151.82 53.47"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 0.5,
    width: 81.39,
    height: 81.39,
    rx: 8.06,
    ry: 8.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.8,28.38v24.99h8.92v-24.99h-8.92ZM56.96,51.07h-3.38v-20.3h3.38v20.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.85,28.38v24.99h8.92v-24.99h-8.92ZM29,51.07h-3.38v-20.3h3.38v20.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.93,26.54v28.79h10.76v-28.79h-10.76ZM43.12,53.37h-3.96v-24.99l3.96.04v24.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.96,65.28h-7.03s-43.52,0-43.52,0h-6.94c1.17-.51,2.68-1.3,4.25-2.53,1.48-1.16,2.56-2.37,3.31-3.33h13.51v1.92s15.4.02,15.4.02l.02-1.92h13.5c.73.96,1.8,2.16,3.26,3.32,1.56,1.24,3.07,2.02,4.23,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.12,21.53c0,2.71-2.36,4.84-4.96,4.84-2.3,0-4.09-1.77-4.65-3.84h-11.51s0-1.86,0-1.86h-15.42v1.85s-11.57-.02-11.57-.02c-.56,2.07-2.5,3.87-4.8,3.87-2.56,0-4.97-2.09-4.96-4.84,0-2.59,2.14-4.78,4.81-4.83h47.74c2.87-.2,5.3,2.09,5.31,4.83Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logoFooter.3ad009f926af075f5e92df2b8d51ff2a.svg";
export { ForwardRef as ReactComponent };